<template>
  <div v-if="profile" class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view :profile=profile></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'Profile',
  components: { ContentTabBar },
  computed: {
    ...mapState('primary', ['profile']),
    ...mapState('route', ['name']),
    tabs() {
      return [
        {
          label: 'Summary',
          link: {
            name: 'profiles.index.detail',
            params: { id: this.profile.id },
          },
          icon: 'info',
        },
        {
          label: 'Analytics',
          link: {
            name: 'profiles.index.analytics',
            params: { id: this.profile.id },
          },
          icon: 'logic',
        },
        {
          label: 'Edit',
          link: {
            name: 'profiles.index.edit',
            params: { id: this.profile.id },
          },
          icon: 'edit',
        },
        {
          label: 'Delete',
          link: {
            name: 'profiles.index.delete',
            params: { id: this.profile.id },
          },
          icon: 'delete',
        },
        {
          label: 'Generated Config',
          link: {
            name: 'profiles.index.jwt',
            params: { id: this.profile.id },
          },
          icon: 'json',
        },
      ];
    },
  },
  beforeMount() {
    this.$store.dispatch('primary/getProfile', {
      id: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

</style>
